import { openBlock as o, createElementBlock as t, createElementVNode as r } from "vue";
const l = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function n(c, e) {
  return o(), t("svg", l, [...e[0] || (e[0] = [
    r("path", {
      stroke: "currentColor",
      d: "m19.35 11.928-3.71 6.428H8.216l-3.71-6.428L8.216 5.5l7.423-.001z"
    }, null, -1),
    r("circle", {
      cx: "12",
      cy: "12",
      r: "3.5",
      stroke: "currentColor"
    }, null, -1),
    r("circle", {
      cx: "12",
      cy: "12",
      r: "1.5",
      fill: "currentColor",
      stroke: "currentColor"
    }, null, -1)
  ])]);
}
const s = { render: n };
export {
  s as default,
  n as render
};
